import { render, staticRenderFns } from "./TableCustomization.vue?vue&type=template&id=2b07b732&scoped=true&"
import script from "./TableCustomization.vue?vue&type=script&lang=js&"
export * from "./TableCustomization.vue?vue&type=script&lang=js&"
import style0 from "./TableCustomization.vue?vue&type=style&index=0&id=2b07b732&prod&lang=scss&scoped=true&"
import style1 from "./TableCustomization.vue?vue&type=style&index=1&id=2b07b732&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b07b732",
  null
  
)

export default component.exports